import { computed, inject, Injectable, signal } from '@angular/core';
import { ComponentStoreV2Factory } from '../../../../shared/store/common/component-store-v2.factory';
import { FolderGlobalStore } from '../../../../../store/medicalService/folder.global-store';
import { OrganizationGlobalStore } from '../../../../../store/organization.global-store';
import { ServiceTypeEnum } from '@libs/types/src/services/enum/service-type.enum';
import { InfiniteScrollStore } from '../../../../shared/store/common/infinite-scroll.store';
import { AddressBookContactObject } from '@libs/types/src/address-book/object-type/address-book-contact.object';
import { AddressBookContactTypeEnum } from '@libs/types/src/address-book/enum/address-book-contact-type.enum';
import { addressBookContactFullDetailFrag } from '../../../../../services/types/address-book.gql-types';
import { FilterBuilder } from '@libs/shared/utils/grid.builder';

@Injectable()
export class PersonContactUpsertDialogStore2 extends ComponentStoreV2Factory {

    public readonly folderStore = inject(FolderGlobalStore);
    public readonly organizationStore = inject(OrganizationGlobalStore);

    public newWorkplace = signal<any | null>(null);
    public userWorkplaces = signal<any[]>([]);
    public workplaces = computed(() => {
        const newWorkplace = this.newWorkplace();
        const workplaces = this.userWorkplaces();

        return [...workplaces, newWorkplace].filter((it) => !!it);
    });

    public currentService = this.organizationStore.getServiceBySignalId(this.folderStore.serviceId);
    public isSocial = computed(() => this.currentService()?.type === ServiceTypeEnum.SOCIAL);

    public readonly customContacts = new InfiniteScrollStore<AddressBookContactObject>(
        this.api.getAddressBookContacts,
        FilterBuilder.filter({
            organizationId: this.organizationStore.selectedId(),
            type: AddressBookContactTypeEnum.CUSTOM,
            sort: { column: 'fullName', direction: 'ASC' },
        }),
        true,
        addressBookContactFullDetailFrag,
    );
}
